import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100vw;
  max-width: 460px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  /* overflow: hidden; */
  max-height: fit-content;

  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
  position: relative;
  z-index: 1000;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    border-radius: 16px;
  }
`;
export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;

  font-weight: 600;

  letter-spacing: -0.09px;
`;

export const Tabs = styled.div`
  border-radius: 100px;
  background: #060e1a;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  position: relative;
  width: 100%;
  /* max-width: 369px; */

  &::before {
    content: "";
    position: absolute;
    top: 2px;
    left: ${({ $activeTab }) =>
      $activeTab === "public" ? "2px" : "calc(50% + 1px)"};
    width: calc(50% - 2px);
    height: calc(100% - 4px);

    border: 0.5px solid #2877d9;
    background: #142743;

    border-radius: 100px;
    transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
  }
`;

export const Tab = styled.div`
  display: flex;
  height: 34px;
  padding: 8px 12px;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  cursor: pointer;
  position: relative;

  border-radius: 100px;
  border: none;
  background: transparent;
  z-index: 3;
  font-family: Figtree;
  color: ${(p) => (p.$active ? "#fff" : "rgba(255,255,255,0.5)")};
  font-size: 14px;
  font-weight: ${(p) => (p.$active ? 600 : 400)};
  letter-spacing: -0.21px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;
export const ImageRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
  position: relative;

  @media (max-width: 480px) {
    gap: 8px;
  }
`;
export const Line = styled.div`
  border-radius: 100px;
  background: #1c3659;
  width: 100%;
  margin-left: 12px;
  height: 1px;
  flex: 1;
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;

export const Button = styled.button`
  display: flex;
  height: 44px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  border-radius: 100px;
  background: #fff;

  color: #0f2c32;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;

  cursor: pointer;
  border: none;
  outline: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export const ArrowContainer = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
`;

export const ModalMessage = styled.p`
  color: #fff;
  text-align: left;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px; /* 133.333% */
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-direction: column;
`;

export const RateButton = styled.button`
  display: flex;
  padding: 12px 12px 12px 6px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 44px;

  border-radius: 12px;
  border: ${({ $ratingUp, $ratingDown }) =>
    $ratingUp
      ? "0.5px solid #28D960"
      : $ratingDown
        ? "0.5px solid #FF5959"
        : "0.5px solid #325682"};

  background: #142743;

  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const ConfirmButton = styled.button`
  display: flex;
  min-width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: ${({ $type }) => {
    switch ($type) {
      case "danger":
        return "linear-gradient(135deg, #ff4757, #ff3838)";
      case "success":
        return "linear-gradient(135deg, #2877D9, #c4057a)";
      case "primary":
      default:
        return "#fff";
    }
  }};
  border: none;
  outline: none;

  color: ${({ $type }) => ($type === "primary" ? "#081120" : "#ffffff")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${({ $type }) => {
      switch ($type) {
        case "danger":
          return "0 4px 15px rgba(255, 71, 87, 0.3)";
        case "success":
          return "0 4px 15px rgba(163, 0, 94, 0.3)";
        case "primary":
        default:
          return "0 4px 15px rgba(0, 0, 0, 0.1)";
      }
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  /* padding-inline: 16px; */
`;
export const UploadCard2 = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  height: fit-content;
  border-radius: 12px;
  border: 1px dashed #315480;
  background:
    linear-gradient(0deg, #142743 0%, #142743 100%),
    url(<path-to-image>) lightgray 50% / cover no-repeat;
`;
export const UploadDescriptionText = styled.span`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  letter-spacing: -0.408px;

  opacity: 0.5;
`;

export const UploadText = styled.span`
  color: #fff;
  font-family: Lexend;
  font-size: ${(props) => (props.$light ? "13px" : "18px")};
  font-weight: ${(props) => (props.$light ? 300 : 500)};
  line-height: ${(props) => (props.$light ? "18px" : "normal")};
  margin-top: ${(props) => (props.$light ? "-12px" : "0px")};
  opacity: ${(props) => (props.$light ? 0.56 : 1)};
  letter-spacing: ${(props) => (props.$light ? "0" : "-0.408px")};

  cursor: pointer;
  text-decoration-line: underline;
`;

export const Content = styled.div`
  display: flex;
  gap: ${(p) => (p.$column ? "12px" : "4px")};
  flex: 1;
  max-height: 90dvh;
  flex-direction: ${(p) => (p.$column ? "column" : "row")};
  height: calc(90dvh - 168px); /* full viewport height minus footer */
  overflow-y: auto; /* allow scrolling if content is taller */
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: ${({ $numOfColumns }) => `calc(100% / ${$numOfColumns})`};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  flex: 1;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: Figtree;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;
    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const ModalFooter = styled.div`
  height: 44px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SubmitButton = styled.div`
  display: flex;
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: #142743;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.21px;
  cursor: pointer;
`;

export const CancelButton = styled.div`
  display: flex;
  height: 40px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: transparent;
  /* border: 1px solid #fff; */
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.21px;
  cursor: pointer;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const GalleryImage = styled.img`
  border: ${({ $isAdded }) => ($isAdded ? "2px solid #4D9DFF" : "none")};
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  background-color: "#0b1727";
`;

export const UploadImageButton = styled.button`
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.37);
  backdrop-filter: blur(6.85px);
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translate(-50%);
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 32px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 90%;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;
  width: 36px;
  height: 36px;
  padding-bottom: 2px;

  svg {
    path {
      stroke: white;
    }
  }
`;

export const CropButton = styled.button`
  display: flex;
  align-items: center;
  position: absolute;
  top: 5px;
  padding: 6px;
  outline: none;
  border: none;
  right: 5px;
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;

  svg {
    path {
      stroke: white;
    }
  }
`;

export const SelectGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  width: 100%;
`;

export const SelectImageWrapper = styled.div`
  position: relative;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  border: ${({ $selected }) =>
    $selected ? "2px solid #2877d9" : "2px solid transparent"};
  transition: border 0.2s ease;
`;

export const SelectImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  border-radius: 6px;
  max-height: 220px;
`;

export const CheckboxOverlay = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
`;

export const ContinueButton = styled.button`
  display: flex;
  height: 44px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  border-radius: 100px;
  background: transparent;
  border: 1px solid #fff;

  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;

  cursor: pointer;
  outline: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ButtonsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const UploadImageContainer = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: 12px;
  background: #0e1c31;
  aspect-ratio: 3 / 4;
  max-height: 280px;
`;

export const AfterImageContainer = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: 12px;
  background: #0e1c31;
  aspect-ratio: 3 / 4;
  max-height: 280px;
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`;

export const AfterImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
`;
